













































import { Vue, Prop, Watch } from 'vue-property-decorator'
import Component from 'vue-class-component'
import { NotFound } from 'vue-kit'
import Delivery from '@/dto/deliveries/Delivery'
import shipmentStore from '@/stores/ShipmentStore'
import DictionariesService from '@/services/DictionariesService'
import DeliveriesTableHeader from '@/components/deliveries/DeliveriesTableHeader.vue'
import PopupMenu from '@/components/deliveries/PopupMenu.vue'
import deliveryStore from '@/stores/DeliveryStore'
import DeliveriesTableRow from '@/components/deliveries/DeliveriesTableRow.vue'

const localStorageKey = 'deliveriesTablePagination'

@Component({
  components: {
    NotFound,
    DeliveriesTableRow,
    PopupMenu,
    DeliveriesTableHeader,
  },
})
export default class DeliveriesTable extends Vue {
  @Prop(Array)
  public deliveries!: Delivery[]

  dictionaries = DictionariesService
  shipmentStore = shipmentStore
  deliveryStore = deliveryStore
  searchQuery: string = ''

  pagination = {
    rowsPerPage: 1000,
  }

  columns = [
    {
      name: 'name',
      align: 'left',
      label: 'Название',
      field: 'name',
      sortable: true,
    },
    {
      name: 'type',
      align: 'left',
      label: 'Способ доставки',
      field: 'type',
      sortable: true,
    },
    {
      name: 'calculatorType',
      align: 'left',
      label: 'Тип расчета',
      field: 'calculatorType',
      sortable: true,
    },
    {
      name: 'actions',
      align: 'left',
      label: '',
      field: 'actions',
    },
  ]

  created() {
    const pagination = localStorage.getItem(localStorageKey)

    if (pagination) {
      this.pagination = JSON.parse(pagination)
    }
  }

  get selectedRow() {
    return this.deliveryStore.delivery ? [this.deliveryStore.delivery] : []
  }

  get filteredDeliveries() {
    if (!this.searchQuery) {
      return this.deliveries
    }

    return this.deliveries.filter((delivery: Delivery) => {
      const { name, type, calculatorType } = delivery

      const typeLabel = this.dictionaries.getDeliveryTypeLabel(type)
      const calculatorTypeLabel = this.dictionaries.getCalculatorTypeLabel(
        calculatorType
      )

      const query = this.searchQuery.toLowerCase()

      return (
        name.toLowerCase().includes(query) ||
        typeLabel.toLowerCase().includes(query) ||
        calculatorTypeLabel.toLowerCase().includes(query)
      )
    })
  }

  @Watch('pagination')
  localSavePagination(pagination: { descending: boolean; sortBy: string }) {
    localStorage.setItem(localStorageKey, JSON.stringify(pagination))
  }

  @Watch('shipmentStore.shipmentPointId')
  resetSearchQuery() {
    this.searchQuery = ''
  }
}
